import { TgCard } from '@/lib/shared/components/Cards/TgCard';

import cn from 'clsx';
import Image from 'next/image';

import styles from './TgBlock.module.scss';

type TgBlockProps = {
  type?: 'rent';
  href?: string;
};

export const TgBlock = ({
  type,
  href = 'https://t.me/villacarte',
}: TgBlockProps) => {
  return (
    <div className={styles.tgBlock}>
      <div className={cn(styles.container, styles.tgBlock__wrapper)}>
        <TgCard type={type} href={href} />
        <Image
          src={
            type === 'rent'
              ? '/images/telegramRent.webp'
              : '/images/telegramApp.webp'
          }
          sizes="(max-width: 1199px) 345px, 480px"
          width={345}
          height={361}
          alt="telegram-app-image"
          style={{ objectFit: 'cover' }}
          loader={({ src }) => src}
          className={styles.tgBlock__telegramApp}
        />
      </div>
    </div>
  );
};
